import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

export const externalUserMutations = {

  [types.ExternalUsers.SET.ALL](state, payload) {
    console.log('externalUserList', payload)
    state.externalUserList = payload;
  },

  [types.SelectedExternalUser.SET.SINGLE](state, payload) {
    console.log('externalUserDetails', payload)
    state.externalUserDetails = payload;
  },
  [types.RoyaltyAccounts.SET.ALL](state, payload) {
    state.externalUserDetails = {
      ...state.externalUserDetails,
      royalty_accounts: payload
    };
  },
  [types.AllExternalUsers.SET.ALL](state, payload) {
    state.externalUserList = {
      ...state.externalUserList,
      ext_users: payload
    };
  },
  ...implementSetAllNavTabDetailsMutation(types.ExternalUserDetails, 'externalUserDetails')
};